import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuCheckboxItem,
} from '@/components/ui/dropdown-menu';
import { MoreVertical, PackagePlus, Grid3x3, List } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export type ProductView = 'grid' | 'list';

interface SaleMobileActionsDropdownProps {
  productView: ProductView;
  onProductViewChange: (view: ProductView) => void;
  onReceiveStock: () => void;
}

export function SaleMobileActionsDropdown({
  productView,
  onProductViewChange,
  onReceiveStock,
}: SaleMobileActionsDropdownProps) {
  const { t } = useTranslation('sale');
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className="sm:hidden">
        <Button size="sm" variant="outline" className="h-9 w-9 p-0">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <div className="px-2 py-1.5 text-sm font-semibold text-muted-foreground">View Mode</div>

        <DropdownMenuCheckboxItem
          checked={productView === 'grid'}
          onCheckedChange={() => onProductViewChange('grid')}
          className="py-3"
        >
          <Grid3x3 className={`mr-2 h-5 w-5 ${productView === 'grid' ? 'text-primary' : ''}`} />
          <span className={productView === 'grid' ? 'font-bold' : ''}>Grid View</span>
        </DropdownMenuCheckboxItem>

        <DropdownMenuCheckboxItem
          checked={productView === 'list'}
          onCheckedChange={() => onProductViewChange('list')}
          className="py-3"
        >
          <List className={`mr-2 h-5 w-5 ${productView === 'list' ? 'text-primary' : ''}`} />
          <span className={productView === 'list' ? 'font-bold' : ''}>List View</span>
        </DropdownMenuCheckboxItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem onClick={onReceiveStock}>
          <PackagePlus className="mr-2 h-4 w-4" />
          <span>{t('receiveStock')}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
